module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "excel-upload-input",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleClick
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "drop"
    },
    on: {
      "drop": _vm.handleDrop,
      "dragover": _vm.handleDragover,
      "dragenter": _vm.handleDragover
    }
  }, [_vm._v("\n    拖拽文件到此处 或者\n    "), _c('el-button', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "loading": _vm.loading,
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("浏览")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c543b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadExcel/index.vue
// module id = 1181
// module chunks = 2